const TPC_URL = "https://dev.insightwin.com/backend/tpc";

export default TPC_URL;
